import { useEffect, useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Link, useSearch } from 'wouter';

export default function SummerInterest() {
  const search = useSearch();
  const [submitted, setSubmitted] = useState(false);
  const [manualEmail, setManualEmail] = useState('');
  const [showForm, setShowForm] = useState(false);

  // Auto-register the contact if their email was passed through the marketing link.
  // They become a Summer 2027 Priority List contact (Brevo list 71, renamed).
  useEffect(() => {
    const params = new URLSearchParams(search);
    const email = (params.get('email') || '').trim().toLowerCase();
    if (!email || !email.includes('@')) {
      setShowForm(true);
      return;
    }
    fetch('/api/marketing/summer-interest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
      .then(() => setSubmitted(true))
      .catch(() => setSubmitted(true));
  }, [search]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const email = manualEmail.trim().toLowerCase();
    if (!email || !email.includes('@')) return;
    await fetch('/api/marketing/summer-interest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    }).catch(() => {});
    setSubmitted(true);
    setShowForm(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full text-center">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10">
            <div className="text-5xl mb-6">☀️</div>
            {submitted ? (
              <>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  You're on the 2027 priority list
                </h1>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  We're holding the Summer Live Classes programme for 2027 so we can give it the proper rollout. You'll be the first to know when registration opens.
                </p>
                <p className="text-gray-600 mb-8">
                  In the meantime, your child can keep learning year-round on EduFocal Academy from J$2,500/month.
                </p>
                <a
                  href="/signup"
                  className="inline-block bg-purple-700 text-white font-semibold px-8 py-3 rounded-lg hover:bg-purple-800 transition-colors"
                >
                  Start a free trial
                </a>
              </>
            ) : showForm ? (
              <>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  Summer Live Classes: paused until 2027
                </h1>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  We're holding the programme for 2027 so we can give it the proper rollout. Leave your email and you'll be first in line when registration opens.
                </p>
                <form onSubmit={onSubmit} className="space-y-3">
                  <input
                    type="email"
                    required
                    value={manualEmail}
                    onChange={(e) => setManualEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
                  />
                  <button
                    type="submit"
                    className="w-full bg-purple-700 text-white font-semibold px-8 py-3 rounded-lg hover:bg-purple-800 transition-colors"
                  >
                    Add me to the 2027 priority list
                  </button>
                </form>
                <p className="text-sm text-gray-500 mt-6">
                  Your child can still join EduFocal Academy today from J$2,500/month for year-round learning.
                </p>
              </>
            ) : (
              <>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  Adding you to the list...
                </h1>
                <p className="text-gray-500">One moment.</p>
              </>
            )}
            <Link href="/">
              <a className="mt-8 inline-block text-purple-700 font-medium hover:text-purple-800">
                Back to EduFocal Academy
              </a>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
